import { render, staticRenderFns } from "./GenerateRegisterationCode.vue?vue&type=template&id=e1a6ee84&"
import script from "./GenerateRegisterationCode.vue?vue&type=script&lang=js&"
export * from "./GenerateRegisterationCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports